import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 32,
	viewBox: "0 0 25 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.7292 8.04578C19.5569 7.92694 19.3354 7.92694 19.1385 8.02201C19.1138 8.02201 17.1938 8.92518 15.7169 8.92518C14.3138 8.92518 13.3538 8.49736 12.2954 8.02201C11.1631 7.52289 10.0062 7 8.30769 7C6.33846 7 4.39385 7.97447 4.32 8.02201C4.12308 8.14085 4 8.33099 4 8.56866V11.706V17.0537V24.4058C4 24.7386 4.27077 25 4.61538 25C4.96 25 5.23077 24.7386 5.23077 24.4058V17.4102C5.82154 17.1488 7.07692 16.6734 8.30769 16.6734C9.85846 16.6734 10.8677 17.125 11.9015 17.6004C12.96 18.0757 14.0677 18.5748 15.6923 18.5748C17.6123 18.5748 19.5815 17.6004 19.68 17.5528C19.8769 17.4577 20 17.2438 20 17.0299V8.56866C20 8.35475 19.9015 8.16461 19.7292 8.04578Z",
		fill: "#FC6917"
	})
});
export default SvgFlag;
